import { render, staticRenderFns } from "./TopCustomersList.vue?vue&type=template&id=71efb8f4&scoped=true&"
import script from "./TopCustomersList.vue?vue&type=script&lang=js&"
export * from "./TopCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./TopCustomersList.vue?vue&type=style&index=0&id=71efb8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efb8f4",
  null
  
)

export default component.exports